import { render, staticRenderFns } from "./Tickets_Liste.vue?vue&type=template&id=4b7725c3&scoped=true"
import script from "./Tickets_Liste.vue?vue&type=script&lang=js"
export * from "./Tickets_Liste.vue?vue&type=script&lang=js"
import style0 from "./Tickets_Liste.vue?vue&type=style&index=0&id=4b7725c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7725c3",
  null
  
)

export default component.exports